/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Eventreport_Example_Item41Inputs */

const ja_playdata_eventreport_example_item41 = /** @type {(inputs: Playdata_Eventreport_Example_Item41Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`競合チャンネル分析`)
};

const en_playdata_eventreport_example_item41 = /** @type {(inputs: Playdata_Eventreport_Example_Item41Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Competitive channel analysis`)
};

/**
* | output |
* | --- |
* | "Competitive channel analysis" |
*
* @param {Playdata_Eventreport_Example_Item41Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_eventreport_example_item41 = /** @type {((inputs?: Playdata_Eventreport_Example_Item41Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Eventreport_Example_Item41Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_eventreport_example_item41(inputs)
	return en_playdata_eventreport_example_item41(inputs)
});
export { playdata_eventreport_example_item41 as "playdata_eventReport_example_item4" }